<template>
    <footer class="footer">
        <div class="content has-text-centered">
            <a
                :href="mailtoLink"
                class="help-link"
            >
                Need help / Report an issue
            </a>
        </div>
    </footer>
</template>

<script>
export default {
    computed: {
        mailtoLink() {
            const to = 'apexbt.sg@gmail.com';
            const subject = encodeURIComponent('Need Help / Issue Report');
            const body = encodeURIComponent('Please describe what help you need or the issue you are experiencing, and attach any relevant screenshots:\n\n');
            return `mailto:${to}?subject=${subject}&body=${body}`;
        },
    },
};
</script>

<style scoped>
.footer {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    color: white;
    text-align: center;
    padding: 4px 0;
}

.help-link {
    font-size: 0.75rem;
    color: #555;
    text-decoration: underline;
}

.help-link:hover {
    color: #222;
}
</style>